import instance from './axiosInstance';
import { DimensionPayload, DimensionMeta } from '@components/dimension-management/utils/types';

export const getDimensionMeta = async <T = DimensionMeta>(): Promise<T> => {
  const resp = await instance.get<T>('/dimensions/management/meta');
  return resp.data;
};

export const getDimensionData = async <T = DimensionPayload>(): Promise<T> => {
  const resp = await instance.get<T>('/dimensions/management/list');
  return resp.data;
};

export const updateDimension = async (data: DimensionPayload) => {
  const res = await instance.post(`/dimensions/management/edit`, data);
  return res.data;
};
